import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/common';
import { HomeSimple, WarningCircle } from 'iconoir-react';
import { routes } from '../../lib/routes';

/**
 * BUG-022 FIX: 404 Not Found Page
 * Shows a user-friendly error page instead of silently redirecting
 */
const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='min-h-screen bg-gray-50 flex items-center justify-center px-4'>
      <div className='text-center max-w-md'>
        <div className='mb-6'>
          <WarningCircle className='w-24 h-24 text-primary-300 mx-auto' />
        </div>
        <h1 className='text-6xl font-bold text-heading-500 mb-2'>404</h1>
        <h2 className='text-2xl font-semibold text-heading-400 mb-4'>
          Page Not Found
        </h2>
        <p className='text-body-500 mb-8'>
          The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>
        <div className='flex flex-col sm:flex-row gap-3 justify-center'>
          <Button
            variant='solid'
            color='primary'
            onClick={() => navigate(routes.home)}
          >
            <HomeSimple className='w-5 h-5' />
            Go to Dashboard
          </Button>
          <Button
            variant='outline'
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
